
import { WorldCity } from '../types';

// Expansión de Rumania - 85 ciudades adicionales
export const romaniaAdditionalCities: WorldCity[] = [
  { name: 'Cluj-Napoca', slug: 'cluj-napoca', population: 324576 },
  { name: 'Timisoara', slug: 'timisoara', population: 319279 },
  { name: 'Iasi', slug: 'iasi', population: 290422 },
  { name: 'Constanta', slug: 'constanta', population: 283872 },
  { name: 'Craiova', slug: 'craiova', population: 269506 },
  { name: 'Brasov', slug: 'brasov', population: 253200 },
  { name: 'Galati', slug: 'galati', population: 249432 },
  { name: 'Ploiesti', slug: 'ploiesti', population: 201226 },
  { name: 'Oradea', slug: 'oradea', population: 196367 },
  { name: 'Braila', slug: 'braila', population: 180302 },
  { name: 'Arad', slug: 'arad', population: 159704 },
  { name: 'Pitesti', slug: 'pitesti', population: 155383 },
  { name: 'Sibiu', slug: 'sibiu', population: 147245 },
  { name: 'Bacau', slug: 'bacau', population: 144307 },
  { name: 'Targu Mures', slug: 'targu-mures', population: 134290 },
  { name: 'Baia Mare', slug: 'baia-mare', population: 123738 },
  { name: 'Buzau', slug: 'buzau', population: 115494 },
  { name: 'Botosani', slug: 'botosani', population: 106847 },
  { name: 'Satu Mare', slug: 'satu-mare', population: 102441 },
  { name: 'Ramnicu Valcea', slug: 'ramnicu-valcea', population: 98776 },
  { name: 'Suceava', slug: 'suceava', population: 92121 },
  { name: 'Piatra Neamt', slug: 'piatra-neamt', population: 85055 },
  { name: 'Drobeta-Turnu Severin', slug: 'drobeta-turnu-severin', population: 92617 },
  { name: 'Focsani', slug: 'focsani', population: 79315 },
  { name: 'Tulcea', slug: 'tulcea', population: 73707 },
  { name: 'Targu Jiu', slug: 'targu-jiu', population: 82504 },
  { name: 'Bistrita', slug: 'bistrita', population: 70038 },
  { name: 'Slatina', slug: 'slatina', population: 70293 },
  { name: 'Calarasi', slug: 'calarasi', population: 65181 },
  { name: 'Alba Iulia', slug: 'alba-iulia', population: 63536 },
  { name: 'Deva', slug: 'deva', population: 61123 },
  { name: 'Zalau', slug: 'zalau', population: 56202 },
  { name: 'Sfantu Gheorghe', slug: 'sfantu-gheorghe', population: 52835 },
  { name: 'Vaslui', slug: 'vaslui', population: 55407 },
  { name: 'Hunedoara', slug: 'hunedoara', population: 58663 },
  { name: 'Turda', slug: 'turda', population: 47744 },
  { name: 'Medias', slug: 'medias', population: 47204 },
  { name: 'Onesti', slug: 'onesti', population: 44232 },
  { name: 'Miercurea Ciuc', slug: 'miercurea-ciuc', population: 38966 },
  { name: 'Petrosani', slug: 'petrosani', population: 34331 },
  { name: 'Reghin', slug: 'reghin', population: 33281 },
  { name: 'Lugoj', slug: 'lugoj', population: 40361 },
  { name: 'Medgidia', slug: 'medgidia', population: 39780 },
  { name: 'Pascani', slug: 'pascani', population: 33745 },
  { name: 'Tecuci', slug: 'tecuci', population: 34871 },
  { name: 'Mangalia', slug: 'mangalia', population: 38759 },
  { name: 'Campia Turzii', slug: 'campia-turzii', population: 23421 },
  { name: 'Fagaras', slug: 'fagaras', population: 28330 },
  { name: 'Nasaud', slug: 'nasaud', population: 10402 },
  { name: 'Gherla', slug: 'gherla', population: 20982 },
  { name: 'Dej', slug: 'dej', population: 33497 },
  { name: 'Blaj', slug: 'blaj', population: 18090 },
  { name: 'Sebes', slug: 'sebes', population: 27019 },
  { name: 'Aiud', slug: 'aiud', population: 22876 },
  { name: 'Cugir', slug: 'cugir', population: 22414 },
  { name: 'Ocna Mures', slug: 'ocna-mures', population: 15697 },
  { name: 'Brad', slug: 'brad', population: 12993 },
  { name: 'Hateg', slug: 'hateg', population: 9685 },
  { name: 'Lupeni', slug: 'lupeni', population: 23390 },
  { name: 'Vulcan', slug: 'vulcan', population: 22602 },
  { name: 'Petrila', slug: 'petrila', population: 8331 },
  { name: 'Aninoasa', slug: 'aninoasa', population: 3340 },
  { name: 'Uricani', slug: 'uricani', population: 8090 },
  { name: 'Motru', slug: 'motru', population: 19079 },
  { name: 'Rovinari', slug: 'rovinari', population: 12603 },
  { name: 'Novaci', slug: 'novaci', population: 5581 },
  { name: 'Bumbesti-Jiu', slug: 'bumbesti-jiu', population: 8290 },
  { name: 'Tismana', slug: 'tismana', population: 7935 },
  { name: 'Turceni', slug: 'turceni', population: 6641 },
  { name: 'Targu Carbunesti', slug: 'targu-carbunesti', population: 8034 },
  { name: 'Bals', slug: 'bals', population: 20418 },
  { name: 'Caracal', slug: 'caracal', population: 30954 },
  { name: 'Corabia', slug: 'corabia', population: 16441 },
  { name: 'Calafat', slug: 'calafat', population: 17336 },
  { name: 'Bailesti', slug: 'bailesti', population: 18164 },
  { name: 'Filiasi', slug: 'filiasi', population: 16900 },
  { name: 'Segarcea', slug: 'segarcea', population: 7846 },
  { name: 'Dabuleni', slug: 'dabuleni', population: 12181 },
  { name: 'Bechet', slug: 'bechet', population: 3361 },
  { name: 'Vanju Mare', slug: 'vanju-mare', population: 3632 },
  { name: 'Calafat', slug: 'calafat-alt', population: 17336 },
  { name: 'Gura Humorului', slug: 'gura-humorului', population: 13667 },
  { name: 'Campulung Moldovenesc', slug: 'campulung-moldovenesc', population: 16105 },
  { name: 'Vatra Dornei', slug: 'vatra-dornei', population: 14429 },
  { name: 'Radauti', slug: 'radauti', population: 23822 },
  { name: 'Falticeni', slug: 'falticeni', population: 25723 },
  { name: 'Siret', slug: 'siret', population: 7976 },
  { name: 'Dolhasca', slug: 'dolhasca', population: 11009 },
  { name: 'Liteni', slug: 'liteni', population: 2864 },
  { name: 'Solca', slug: 'solca', population: 4887 }
];

export const romaniaExpanded = {
  code: 'RO',
  name: 'Romania',
  slug: 'romania',
  population: 19237691,
  topCities: [
    { name: 'Bucharest', slug: 'bucharest', population: 1883425 },
    ...romaniaAdditionalCities
  ]
};
